const LEGACY_COOKIE_AKAMAI_ZIP = "client-zip-short";
const LEGACY_COOKIE_CART_COUNT = "cartCountCookie";
const LEGACY_COOKIE_DELIVERY_LOCATION_CITY = "invCheckCity";
const LEGACY_COOKIE_DELIVERY_LOCATION_STATE_CODE = "invCheckStateCode";
const LEGACY_COOKIE_DELIVERY_LOCATION_ZIP_CODE = "invCheckPostalCode";
const LEGACY_COOKIE_ONE_TRUST = "OptanonConsent";
const LEGACY_COOKIE_STORE_LOCATION = "STORELOCATION";
const LEGACY_COOKIE_WAREHOUSE_DELIVERY = "WAREHOUSEDELIVERY_WHS";
const LEGACY_COOKIE_WC_CART_ORDER = "wcCartOrder";
const LEGACY_COOKIE_WC_MEMMBER = "wcMember";
const LEGACY_COOKIE_WC_BD_WHS = "WC_BD_WHS";
const LEGACY_COOKIE_WC_BD_ZIP = "WC_BD_ZIP";
const LEGACY_COOKIE_WC_BD_ZIP_ORIGINAL = "WC_BD_ZIP_ORIGINAL";
const LEGACY_COOKIE_WC_BD_LOC = "WC_BD_LOC";
const LS_USER_PREFERENCES = "user_preferences";
const MAX_COOKIE_EXPIRATION_DAYS = 400;
const MAX_WAREHOUSE_COOKIE_EXPIRATION_DAYS = 1;
const MAX_STORE_LOCATION_COOKIE_EXPIRATION_DAYS = 180;
const WAREHOUSE_RESET_SESSION_STORAGE_FLAG = "warehouseCookieExpResetFlag";
const STORE_LOCATION_RESET_SESSION_STORAGE_FLAG = "storeLocCookieExpResetFlag";
const MINI_BANNER_DETAILS_SESSION_STORAGE_KEY = "miniBannerDetails";
const LEGACY_COOKIE_WC_BD_WHS_DEFAULT_VALUE = process.env.NEXT_PUBLIC_SITE === "USBD" ? "888" : process.env.NEXT_PUBLIC_SITE === "CABD" ? "889" : "";
export {
  LEGACY_COOKIE_AKAMAI_ZIP,
  LEGACY_COOKIE_CART_COUNT,
  LEGACY_COOKIE_DELIVERY_LOCATION_CITY,
  LEGACY_COOKIE_DELIVERY_LOCATION_STATE_CODE,
  LEGACY_COOKIE_DELIVERY_LOCATION_ZIP_CODE,
  LEGACY_COOKIE_ONE_TRUST,
  LEGACY_COOKIE_STORE_LOCATION,
  LEGACY_COOKIE_WAREHOUSE_DELIVERY,
  LEGACY_COOKIE_WC_BD_LOC,
  LEGACY_COOKIE_WC_BD_WHS,
  LEGACY_COOKIE_WC_BD_WHS_DEFAULT_VALUE,
  LEGACY_COOKIE_WC_BD_ZIP,
  LEGACY_COOKIE_WC_BD_ZIP_ORIGINAL,
  LEGACY_COOKIE_WC_CART_ORDER,
  LEGACY_COOKIE_WC_MEMMBER,
  LS_USER_PREFERENCES,
  MAX_COOKIE_EXPIRATION_DAYS,
  MAX_STORE_LOCATION_COOKIE_EXPIRATION_DAYS,
  MAX_WAREHOUSE_COOKIE_EXPIRATION_DAYS,
  MINI_BANNER_DETAILS_SESSION_STORAGE_KEY,
  STORE_LOCATION_RESET_SESSION_STORAGE_FLAG,
  WAREHOUSE_RESET_SESSION_STORAGE_FLAG
};
